module.exports = __webpack_public_path__ + "static/ChangeNumber-2a71e6ef7bdca24bc1eee51a2b7fdeb6.png";